import * as React from 'react';
import { Component } from 'react';
import './Loader.css';
import { TimelineMax } from "gsap/TweenMax";


interface IProps {
    Visible: boolean,
    Key?: string //Należy używać w przypadku kilku loaderów na stronie
}

interface IState {
    Width?: string,
    Height?: string,
    Padding?: string
}

export class LoaderComponent extends Component<IProps, IState> {
    private LoaderInitialized = false;
    private LoaderRef = React.createRef<HTMLDivElement>();

    constructor(props) {
        super(props);

        this.state = {}

        this.InitLoaderAnimation = this.InitLoaderAnimation.bind(this);
        this.InitLoaderSize = this.InitLoaderSize.bind(this);
        this.InitLoaderAnimationTimeout = this.InitLoaderAnimationTimeout.bind(this);
    }

    public componentDidMount() {
        this.InitLoaderSize();
        this.InitLoaderAnimationTimeout();
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (this.props.Visible !== nextProps.Visible) {
            this.LoaderInitialized = false;
        }
        this.InitLoaderSize();
        this.InitLoaderAnimationTimeout();
    }

    public render() {
        let loaderContainer: JSX.Element | null = null;
        let additionalKey = (this.props.Key ? (this.props.Key + '_') : '');
        if (this.props.Visible) {
            loaderContainer = (
                <div className="loader-container"
                    style={{
                        width: this.state.Width ? this.state.Width : '0px',
                        height: this.state.Height ? this.state.Height : '0px',
                        padding: this.state.Padding ? this.state.Padding : '0px'
                    }}>
                    <svg
                        className="loader"
                        height="57"
                        stroke="#fff"
                        viewBox="0 0 57 57"
                        width="57">
                        <g fillRule="evenodd" fill="none">
                            <g strokeWidth="2" transform="translate(1 1)">
                                <circle className={'loader12__path-left' + additionalKey}
                                    cx="5" cy="50" r="5" />
                                <circle className={'loader12__path-top' + additionalKey}
                                    cx="27" cy="5" r="5" />
                                <circle className={'loader12__path-right' + additionalKey}
                                    cx="50" cy="50" r="5" />
                            </g>
                        </g>
                    </svg>
                </div>
            );
        }
        return (
            <div className="loader-component" ref={this.LoaderRef}>
                {loaderContainer}
            </div>
        );
    }

    private InitLoaderAnimationTimeout() {
        setTimeout((t) => {
            t.InitLoaderAnimation();
        }, 100, this);
        setTimeout((t) => {
            t.InitLoaderAnimation();
        }, 300, this);
        setTimeout((t) => {
            t.InitLoaderAnimation();
        }, 500, this);
        setTimeout((t) => {
            t.InitLoaderAnimation();
        }, 1000, this);
    }

    private OnParentChange(evt) { }

    private InitLoaderSize() {
        if (this.LoaderRef.current !== null && this.LoaderRef.current.parentElement !== null) {
            this.LoaderRef.current.parentElement.addEventListener('change', this.OnParentChange, false);
            if (this.state.Width !== (this.LoaderRef.current.parentElement.clientWidth + 'px') ||
                this.state.Height !== (this.LoaderRef.current.parentElement.clientHeight + 'px')
            ) {
                this.setState({
                    Width: (this.LoaderRef.current.parentElement.clientWidth + 'px'),
                    Height: (this.LoaderRef.current.parentElement.clientHeight + 'px'),
                    Padding: (
                        ((this.LoaderRef.current.parentElement.clientWidth + this.LoaderRef.current.parentElement.clientHeight) / 20) + 'px'
                    )
                });
            }
        }
    }

    private InitLoaderAnimation() {
        if (!this.LoaderInitialized) {
            const loader12Timeline = new TimelineMax({ repeat: -1 });
            let additionalKey = (this.props.Key ? (this.props.Key + '_') : '');
            loader12Timeline.to('.loader12__path-top' + additionalKey, 0.75, {
                attr: {
                    cx: 50,
                    cy: 50
                }
            }, "l12_1" + additionalKey)
                .to('.loader12__path-left' + additionalKey, 0.75, {
                    attr: {
                        cx: 27,
                        cy: 5
                    }
                }, "l12_1" + additionalKey)
                .to('.loader12__path-right' + additionalKey, 0.75, {
                    attr: {
                        cx: 5,
                        cy: 50
                    }
                }, "l12_1" + additionalKey);
            this.LoaderInitialized = true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/controls/Loader.tsx